import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";

import App from "./App";
import "./index.css";
// Tema (chiaro/scuro) e installazione sull telefono: vanno caricati subito,
// il primo per applicare la scelta, il secondo perche' l'evento
// `beforeinstallprompt` arriva una volta sola poco dopo il caricamento.
import "./lib/tema";
import "./lib/installazione";
// Lingua (italiano/inglese): va prima del primo render
import "./i18n";

// PWA service worker (FASE 7 iter 6): autoUpdate + reload silenzioso quando
// arriva una nuova versione. In dev è disabilitato (devOptions.enabled=false).
const updateSW = registerSW({
  onNeedRefresh() {
    // Auto-refresh quando una nuova build è disponibile: la UI fa diff cache
    // con shell precached, quindi è safe ricaricare.
    updateSW(true);
  },
  onOfflineReady() {
    // eslint-disable-next-line no-console
    console.info("[pwa] offline ready");
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30s
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
